import r from "./design-system.es38.js";
import { resolveComponent as n, openBlock as s, createBlock as a, normalizeClass as d, withCtx as i, renderSlot as p } from "vue";
/* empty css                    */
import c from "./design-system.es128.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
const m = {
  name: "DsPagerButton",
  components: { DsButton: r },
  props: {
    current: Boolean,
    disabled: Boolean
  }
};
function u(o, l, t, _, f, B) {
  const e = n("DsButton");
  return s(), a(e, {
    variant: "custom",
    disabled: t.disabled,
    class: d(["ds-pager-button", { "ds-pager-button--current": t.current }])
  }, {
    default: i(() => [
      p(o.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  }, 8, ["disabled", "class"]);
}
const z = /* @__PURE__ */ c(m, [["render", u], ["__scopeId", "data-v-17d97106"]]);
export {
  z as default
};
//# sourceMappingURL=design-system.es84.js.map
